import React, { Component } from 'react';
import LoginForm from './LoginForm';

class Login extends Component {
  render() {
    const { containerStyle } = styles;
    return (
      <div style={containerStyle}>
        <LoginForm />
      </div>
    );
  }
}

const styles = {
  containerStyle: {
    backgroundColor: '#eee',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

export default Login;


// WEBPACK FOOTER //
// ./src/screens/login/Login.js